import React from "react";
import styled from "styled-components";
import { Locale } from "@linkfluence/models/locale";
import { tr } from "@radarly/i18n";
import { isEmbeddedImageDataviz } from "@radarly/models/cards/dataviz";
import { DatavizEmbedded } from "@radarly/models/dataviz";
import EmbeddedImage from "@radarly/shared/widgets/embedded/image";
import Web from "@radarly/shared/widgets/embedded/web";

export interface SharedWidgetsEmbeddedProps {
  dataviz: DatavizEmbedded;
  height: number;
  disableAnimation?: boolean;
  isFullscreen?: boolean;
  locale: Locale;
}

const Placeholder = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default function SharedWidgetsEmbedded({
  dataviz,
  height,
  isFullscreen,
  locale,
}: SharedWidgetsEmbeddedProps) {
  const isImage = isEmbeddedImageDataviz(dataviz);

  return !dataviz.url ? (
    <Placeholder>{tr(locale, "EMBEDDED_CARD_PLACEHOLDER")}</Placeholder>
  ) : isImage ? (
    <EmbeddedImage
      dataviz={dataviz}
      height={isFullscreen ? undefined : height}
      locale={locale}
    />
  ) : (
    <Web
      dataviz={dataviz}
      height={isFullscreen ? undefined : height}
      locale={locale}
    />
  );
}
